import Marquee from "react-fast-marquee";
import './navbar.css';
import ReactGA from 'react-ga4'; // Import ReactGA
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();
    const toggleBurger = () => {
        const burger = document.querySelector('.burger') as HTMLElement | null;
        const nav = document.querySelector('.nav-links') as HTMLElement | null;
        const navLinks = document.querySelectorAll<HTMLLIElement>(".nav-links li");

        if (nav) {
            nav.classList.toggle("nav-active");
        }
        if (burger) {
            burger.classList.toggle('toggle');
        }
        
        //Animate Links
        navLinks.forEach((link, index) => {
            if (link.style.animation) {
                link.style.animation = "";
            } else {
                link.style.animation = `navLinkFade 0.5s ease forwards ${index / 7 + 0.4}s`;
            }

            const actualLink = link.querySelector("a");
            if (actualLink) {
                actualLink.onclick = () => {
                    ReactGA.event('nav_link_click', { // Add GA event for link click in burger menu
                        link_name: actualLink.getAttribute('href') || 'Unknown', // Which link was clicked
                        menu: 'burger'
                    });
                    if (nav) {
                        nav.classList.remove("nav-active");
                    }

                    navLinks.forEach((link) => {
                        if (link.style) {
                            link.style.animation = "";
                        }
                    });

                    if (burger) {
                        burger.classList.remove('toggle');
                    }
                };
            }
        });

        ReactGA.event('nav_burger_toggle'); // Add GA event for burger click
    };

    const marqueeActive = false;
    // Marquee colors defined in navbar.css under .marquee
    return (
        <nav>
            {marqueeActive ? (
                <div className="marquee">
                    <Marquee gradient={false}>
                        <p>🚧 This website is under active redevelopment. 👷</p>
                        <p>Some pages may not exist yet, and there may be missing functionality.</p>
                        <p>To report an issue, email web@mattgeimer.com.</p>
                    </Marquee>
                </div>
            ) : null}
            <div id="navbar">
                <div className="logo">
                    <a href="/" onClick={() => {
                        ReactGA.event('nav_logo_click'); // Add GA event for logo click
                    }}>
                        <h4><strong>Matt Geimer</strong></h4>
                    </a>
                </div>
                <ul className="nav-links">
                                        <li>
                                                <Link
                                                    to="/"
                                                    className="nav-link"
                                                    onClick={e => {
                                                        ReactGA.event('nav_link_click', { link_name: 'Home' });
                                                        if (location.pathname === '/') {
                                                            window.scrollTo({
                                                                top: 0,
                                                                left: 0,
                                                                behavior: 'smooth',
                                                            });
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    Home
                                                </Link>
                                        </li>
                    <li>
                        <a href="/#about" onClick={() => {
                            ReactGA.event('nav_link_click', { link_name: 'About' }); // Add GA event for About link click
                        }}>About</a>
                    </li>
                    <li>
                        <a href="/#experiences" onClick={() => {
                            ReactGA.event('nav_link_click', { link_name: 'Experiences' }); // Add GA event for Experiences link click
                        }}>Experiences</a>
                    </li>
                    <li>
                        <a href="/photos" onClick={() => {
                            ReactGA.event('nav_link_click', { link_name: 'Photos' }); // Add GA event for Photos link click
                        }}>Photos</a>
                    </li>
                    <li></li>
                </ul>
    
                <button className="burger" onClick={toggleBurger} title="Button to extend the navbar">
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </button>
            </div>
        </nav>
    );
}

export default Navbar;